import { render } from "./CreateRoleModal.vue?vue&type=template&id=480a6822"
import script from "./CreateRoleModal.vue?vue&type=script&lang=js"
export * from "./CreateRoleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__